<template>
    <div class="auto-login-page">
        <div class="loading-wrapper">
            <el-icon class="is-loading loading-icon" :size="48" color="#409eff">
                <Loading />
            </el-icon>
            <p class="loading-text">正在加载中，请稍候...</p>
        </div>
    </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { getRsa } from '@/api/sys.js'
import JSEncrypt from 'jsencrypt'
import { Base64 } from 'js-base64'
import { ElMessage } from 'element-plus'

const store = useStore()

// 平台自动登录固定验证码
const FIXED_CODE = '!@#*'

// RSA 公钥
const rsaPubkey = ref('')
const getRsaKey = async () => {
    if (rsaPubkey.value) return
    try {
        const data = await getRsa()
        rsaPubkey.value = Base64.decode(data.rsa_pubkey)
    } catch (e) {
        ElMessage.error('获取加密公钥失败，请刷新重试')
    }
}

// 自动登录：与登录页保持一致，先 base64 再 rsa 加密密码
const handleAutoLogin = async (params) => {
    await getRsaKey()
    if (!rsaPubkey.value) return
    const encryptor = new JSEncrypt()
    encryptor.setPublicKey(rsaPubkey.value)
    const b64Password = Base64.encode(params.password) // 先base64加密
    params.password = encryptor.encrypt(b64Password) // 后ras加密
    store.dispatch('user/login', params).catch(() => {
        ElMessage.error('自动登录失败，请重试')
    })
}

// 平台通过 postMessage 传递账号密码
const onPrepayMessage = (e) => {
    if (e.data && e.data.key === 'prepayMessage') {
        console.log('收到参数账号:', e.data.username)
        console.log('收到参数密码:', e.data.password)
        handleAutoLogin({
            username: e.data.username,
            password: e.data.password,
            code: FIXED_CODE
        })
    }
}

onMounted(() => {
    getRsaKey()
    window.addEventListener('message', onPrepayMessage)
})

onBeforeUnmount(() => {
    window.removeEventListener('message', onPrepayMessage)
})
</script>

<style lang="scss" scoped>
.auto-login-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    //background: url('../../assets/images/login-bg.jpg') no-repeat center center / cover;

    .loading-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        padding: 40px 60px;
        border-radius: 12px;
        background-color: rgba(255, 255, 255, 0.85);
        backdrop-filter: blur(8px);

        .loading-icon {
            animation: auto-login-rotate 1s linear infinite;
        }

        .loading-text {
            font-size: 16px;
            color: #303133;
            letter-spacing: 2px;
        }
    }
}

@keyframes auto-login-rotate {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
